import { createContext, useContext } from "react";

export const translations = {
  it: {
    nav: {
      links: [
        { href: "#servizi", label: "Cosa faccio" },
        { href: "#esperienza", label: "Esperienza" },
        { href: "#contatti", label: "Contatti" },
      ],
      cta: "Scrivimi",
    },
    hero: {
      eyebrow: "Sales Account · Trust & Cyber",
      line1a: "La ",
      line1em: "fiducia",
      line1b: "",
      line2: "è il mio mestiere.",
      introA: "Sono ",
      introB: ". Supporto le aziende nella loro trasformazione digitale attraverso consulenza ",
      introC: "Cyber & Trust",
      introD: " e automazione dei processi su misura.",
      ctaPrimary: "Mettiamoci in contatto",
      ctaSecondary: "Cosa faccio",
      cv: "Scarica il CV",
      badge: "Disponibile per una consulenza",
    },
    marquee: [
      "Trust Services",
      "Cyber Security",
      "Digitalizzazione",
      "Automazione dei processi",
      "Firma digitale",
      "Conservazione a norma",
      "Customer Communications Management",
      "B2B SaaS",
    ],
    services: {
      eyebrow: "Cosa faccio",
      titleA: "Due modi in cui posso ",
      titleEm: "aiutarti",
      titleB: ".",
      items: [
        {
          n: "01",
          title: "Consulenza Trust & Cyber",
          desc: "Firma digitale, conservazione a norma, cyber security e adeguamento regolatorio: accompagno le aziende verso una trasformazione digitale sicura, dematerializzata e conforme agli standard internazionali.",
          tags: ["Firma digitale", "Conservazione", "Cyber security", "Compliance"],
        },
        {
          n: "02",
          title: "Soluzioni Digitali Personalizzate",
          desc: "Progetto insieme ai clienti soluzioni digitali su misura per automatizzare i processi: dematerializzazione, Customer Communications Management ed esperienza cliente.",
          tags: ["Automazione", "Digitalizzazione", "CCM", "Customer Experience", "Pec Management", "Processi di OnBoarding"],
        },
      ],
    },
    experience: {
      eyebrow: "Esperienza",
      titleA: "Un percorso costruito ",
      titleEm: "sul campo",
      titleB: ".",
      jobs: [
        {
          company: "TeamSystem S.p.A.",
          role: "Sales Account — BU Trust Services & Cyber",
          period: "2025 · Oggi",
          desc: "Sviluppo del portafoglio clienti e generazione di nuove opportunità in Trust Services e Cyber Security, con vendite dirette e tramite partner, account plan e coordinamento con i team di delivery.",
        },
        {
          company: "Doxee S.p.A.",
          role: "Customer Success Manager — Revenue Team",
          period: "2023 · 2025",
          desc: "Gestione di clienti top nei settori retail, utility, bancario, telco e assicurativo: progettazione della Customer Experience, nuove opportunità di crescita e rinnovi contrattuali.",
        },
        {
          company: "Doxee S.p.A.",
          role: "Client Manager & Service Manager — Operation Team",
          period: "2019 · 2023",
          desc: "Qualità del servizio erogato ai clienti, gestione di change request e project management, monitoraggio KPI, escalation e ottimizzazione costante dei processi.",
        },
      ],
      summaryA: "Prima ancora: dal 2016 in Doxee, anni tra ruoli tecnici e operativi — Service Provisioning, Technical Specialist, Focal Point — che mi hanno fatto conoscere le piattaforme digitali ",
      summaryEm: "dentro",
      summaryB: ".",
    },
    contact: {
      eyebrow: "Contatti",
      title: "Parliamone.",
      desc: "Raccontami la tua sfida: fiducia, sicurezza o un processo da automatizzare. Ti contatterò direttamente per organizzare un appuntamento.",
      rows: [
        { label: "Email", value: "stefano.plaia@hotmail.it", href: "mailto:stefano.plaia@hotmail.it", testid: "contact-email-link", download: false },
        { label: "Telefono", value: "+39 338 107 3063", href: "tel:+393381073063", testid: "contact-phone-link", download: false },
        { label: "LinkedIn", value: "Stefano Plaia", href: "https://www.linkedin.com/in/stefano-plaia/", testid: "contact-linkedin-link", download: false },
        { label: "CV", value: "Scarica il PDF", href: "/Stefano_Plaia_CV.pdf", testid: "contact-cv-download", download: true },
      ],
      form: {
        nome: "Nome e cognome",
        nomePh: "Il tuo nome",
        email: "Email",
        emailPh: "nome@azienda.it",
        telefono: "Telefono",
        telefonoPh: "Il tuo numero di telefono",
        azienda: "Azienda",
        aziendaPh: "L'azienda per cui lavori",
        messaggio: "Messaggio",
        messaggioPh: "Inserisci qui la tua richiesta",
        submit: "Invia il messaggio",
        sending: "Invio in corso...",
        successTitle: "Grazie, {name}.",
        successDesc: "Il tuo messaggio è in viaggio: ti risponderò all'indirizzo che mi hai lasciato.",
        error: "Invio non riuscito. Riprova o scrivimi direttamente via email.",
        required: "*",
      },
    },
    footer: {
      credit: "© 2026 Stefano Plaia · Sales Account Trust & Cyber",
      linkedin: "LinkedIn",
      email: "Email",
    },
  },
  en: {
    nav: {
      links: [
        { href: "#servizi", label: "What I do" },
        { href: "#esperienza", label: "Experience" },
        { href: "#contatti", label: "Contact" },
      ],
      cta: "Get in touch",
    },
    hero: {
      eyebrow: "Sales Account · Trust & Cyber",
      line1a: "Built on ",
      line1em: "trust",
      line1b: ".",
      line2: "",
      introA: "I'm ",
      introB: ". I support companies navigate their digital transformation through ",
      introC: "Cyber & Trust",
      introD: " consultancy and tailored process automation.",
      ctaPrimary: "Let's get in touch",
      ctaSecondary: "What I do",
      cv: "Download CV",
      badge: "Available for a consultation",
    },
    marquee: [
      "Trust Services",
      "Cyber Security",
      "Digital Transformation",
      "Process Automation",
      "Digital Signature",
      "Digital Preservation",
      "Customer Communications Management",
      "B2B SaaS",
    ],
    services: {
      eyebrow: "What I do",
      titleA: "Two ways I can ",
      titleEm: "help you",
      titleB: ".",
      items: [
        {
          n: "01",
          title: "Trust & Cyber Consultancy",
          desc: "Digital signature, legally compliant digital preservation, cyber security and regulatory compliance: I guide companies towards a secure, paperless digital transformation aligned with international standards.",
          tags: ["Digital signature", "Digital preservation", "Cyber security", "Compliance"],
        },
        {
          n: "02",
          title: "Tailored Digital Solutions",
          desc: "Together with clients I design bespoke digital solutions to automate processes: dematerialisation, Customer Communications Management and customer experience.",
          tags: ["Automation", "Digitalisation", "CCM", "Customer Experience", "PEC Management", "Onboarding Processes"],
        },
      ],
    },
    experience: {
      eyebrow: "Experience",
      titleA: "A track record built ",
      titleEm: "in the field",
      titleB: ".",
      jobs: [
        {
          company: "TeamSystem S.p.A.",
          role: "Sales Account — Trust Services & Cyber BU",
          period: "2025 · Present",
          desc: "Portfolio development and generation of new opportunities in Trust Services and Cyber Security, with direct and partner-based sales, account planning and coordination with delivery teams.",
        },
        {
          company: "Doxee S.p.A.",
          role: "Customer Success Manager — Revenue Team",
          period: "2023 · 2025",
          desc: "Managing top accounts in retail, utilities, banking, telco and insurance: designing the customer experience, growth opportunities and contract renewals.",
        },
        {
          company: "Doxee S.p.A.",
          role: "Client Manager & Service Manager — Operation Team",
          period: "2019 · 2023",
          desc: "Quality of delivered services, change request and project management, KPI monitoring, escalations and continuous process optimisation.",
        },
      ],
      summaryA: "Before that: at Doxee since 2016, years in technical and operational roles — Service Provisioning, Technical Specialist, Focal Point — that taught me digital platforms ",
      summaryEm: "from the inside",
      summaryB: ".",
    },
    contact: {
      eyebrow: "Contact",
      title: "Let's talk.",
      desc: "Tell me about your challenge: trust, security, or a process to automate. I'll get in touch directly to schedule a meeting.",
      rows: [
        { label: "Email", value: "stefano.plaia@hotmail.it", href: "mailto:stefano.plaia@hotmail.it", testid: "contact-email-link", download: false },
        { label: "Phone", value: "+39 338 107 3063", href: "tel:+393381073063", testid: "contact-phone-link", download: false },
        { label: "LinkedIn", value: "Stefano Plaia", href: "https://www.linkedin.com/in/stefano-plaia/", testid: "contact-linkedin-link", download: false },
        { label: "CV", value: "Download the PDF", href: "/Stefano_Plaia_CV.pdf", testid: "contact-cv-download", download: true },
      ],
      form: {
        nome: "Full name",
        nomePh: "Your name",
        email: "Email",
        emailPh: "name@company.com",
        telefono: "Phone",
        telefonoPh: "Your phone number",
        azienda: "Company",
        aziendaPh: "The company you work for",
        messaggio: "Message",
        messaggioPh: "Enter your request here",
        submit: "Send your message",
        sending: "Sending...",
        successTitle: "Thank you, {name}.",
        successDesc: "Your message is on its way: I'll get back to you at the address you left me.",
        error: "Sending failed. Please try again or email me directly.",
        required: "*",
      },
    },
    footer: {
      credit: "© 2026 Stefano Plaia · Sales Account Trust & Cyber",
      linkedin: "LinkedIn",
      email: "Email",
    },
  },
};

export const LanguageContext = createContext({ lang: "it", setLang: () => {} });

export const useLanguage = () => useContext(LanguageContext);

export const useCopy = () => {
  const { lang } = useContext(LanguageContext);
  return translations[lang] || translations.it;
};
